export const NAME = 'waferSealElements';
